import { createBrowserRouter } from "react-router-dom";

import Root from "@/pages/root";
import ErrorPage from "@/pages/errors/ErrorPage";
import LoginPage from "@/pages/login";

import ViolationsRoutes from "@/routes/violations";
import AnalystRoutes from "@/routes/analyst";
import ReportRoutes from "@/routes/reports";
import ExternalRoutes from "@/routes/external";
import ApplicationsRoutes from "@/routes/applications";
import ProtectedRoute from "@/components/helpers/ProtectedRoute";

const AppRouter = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      ...AnalystRoutes,
      ...ReportRoutes,
      // ...ExternalRoutes,
      ...ApplicationsRoutes,
      // ...ViolationsRoutes,
    ],
  },
]);

export default AppRouter;
